import store from "@/store";
import _get from "lodash/get";

export default function({ next, to, router }) {
  const permissions = store.state.auth.permissions;

  if (!_get(permissions, "invoices-page--view-page", false)) {
    return router.push({ name: "Error404", params: { "0": to.path } });
  }

  return next();
}
